// extracted by mini-css-extract-plugin
module.exports = {"block":"breadcrumbs_block___LMiL","list":"breadcrumbs_list__2uypF container","item":"breadcrumbs_item__1s3rz"};